/**
 * Returns true if the given latitude/longitude pair represents a valid,
 * non-default search center coordinate.
 *
 * Rejects: null, undefined, empty string, non-numeric, and the (0, 0)
 * null-island sentinel value returned by searchCenter when no location
 * is resolved.
 */
export function hasValidSearchCenterCoordinates(latitude: unknown, longitude: unknown): boolean {
  if (latitude == null || longitude == null || latitude === '' || longitude === '') {
    return false;
  }
  const lat = Number(latitude);
  const lng = Number(longitude);
  // Reject NaN and the (0,0) null-island sentinel
  return !Number.isNaN(lat) && !Number.isNaN(lng) && !(lat === 0 && lng === 0);
}
